import { SessionCropBoxProps } from "@/app/activity/components/deviceTimeline/deviceCropTimeline/deviceCropItemBox/types.ts"
import { colors } from "@/components/colors.ts"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import "./sessionCropBox.scss"

export default function SessionCropBox({
  startX,
  width,
  idfData,
  idfSessionCropRecord,
  localIdfCropNumber,
  cropEndTime,
  cropStartTime,
  idfSession,
  onClick,
}: SessionCropBoxProps) {
  const height = 60
  const lineInterval = 3

  const [isHovered, setIsHovered] = useState<boolean>(false)

  const { t } = useTranslation()

  return (
    <svg
      className="SessionCroppedBoxCont"
      transform={`translate(${startX}, 20)`}
      width={width}
      height={height}
      onMouseOver={(e) => {
        e.stopPropagation()
        setIsHovered(true)
      }}
      onMouseMove={(e) => {
        e.stopPropagation()
        setIsHovered(true)
      }}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        onClick?.({
          idfData,
          idfSessionCropRecord: idfSessionCropRecord as number,
          localIdfCropNumber,
          cropStartTime,
          cropEndTime,
          idfSession,
        })
      }}>
      <defs>
        <pattern
          id={`diagonalHatch-${idfSessionCropRecord ?? localIdfCropNumber}-${idfData}`}
          width={lineInterval}
          height={lineInterval}
          patternTransform="rotate(45)"
          patternUnits="userSpaceOnUse">
          <line x1="0" y1="0" x2="0" y2={lineInterval} strokeWidth="1" stroke={colors.blue[500]} />
        </pattern>
      </defs>
      <rect
        x="1"
        y="0"
        width={Math.max(0, width - 2)}
        height="100%"
        fill="white"
        fillOpacity="0.6"
      />
      <rect
        x="1"
        y="0"
        width="calc(100% - 2px)"
        height="100%"
        fill={`url(#diagonalHatch-${idfSessionCropRecord ?? localIdfCropNumber}-${idfData})`}
        className="cropped-box-diagonal"
      />
      {isHovered && (
        <>
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            alignmentBaseline="middle"
            fontSize="11"
            className="font-weight-medium">
            {t("fillThisSelection")}
          </text>
          <rect y="0" width="calc(100% - 1px)" height="100%" className="cropped-box-border" />
        </>
      )}
    </svg>
  )
}
